import React, { useState, useEffect } from "react";

const DigitalFootprintMemory = () => {
  const levels = [
    {
      level: 1,
      actions: [
        "Post a photo online",
        "Like a friend’s post",
        "Share a video",
        "Comment on a post",
        "Play an online game",
        "Send a message",
      ],
      consequences: [
        "Friends can see it",
        "Shows appreciation to friends",
        "Strangers can copy it",
        "Strangers can copy it",
        "Companies can track your behavior",
        "Personal info can be seen by others",
      ],
    },
    {
      level: 2,
      actions: [
        "Upload a school project online",
        "Follow a new social media account",
        "Click on a game ad",
        "Join an online forum",
        "Share your location online",
        "Post a comment with personal info",
      ],
      consequences: [
        "Strangers can copy it",
        "Companies can track your behavior",
        "You may get unwanted ads or popups",
        "Unknown people can read your posts",
        "Strangers can know your location",
        "Personal info can be misused",
      ],
    },
    {
      level: 3,
      actions: [
        "Post a video on a public platform",
        "Accept friend requests from strangers",
        "Participate in online contests",
        "Download apps from unknown sources",
        "Post your phone number online",
        "Share school events photos",
      ],
      consequences: [
        "Strangers can copy or misuse content",
        "You may get scammed or hacked",
        "Companies can track your activity",
        "Device can get viruses or malware",
        "Personal info can be misused",
        "Privacy might be violated",
      ],
    },
  ];

  const [currentLevel, setCurrentLevel] = useState(0);
  const [cards, setCards] = useState([]);
  const [flippedCards, setFlippedCards] = useState([]);
  const [score, setScore] = useState(0);

  useEffect(() => {
    loadLevel(currentLevel);
  }, [currentLevel]);

  const shuffle = (array) => [...array].sort(() => Math.random() - 0.5);

  const loadLevel = (levelIndex) => {
    const level = levels[levelIndex];
    let newCards = [];
    level.actions.forEach((a) => newCards.push({ text: a, type: "action" }));
    level.consequences.forEach((c) =>
      newCards.push({ text: c, type: "consequence" })
    );
    setCards(shuffle(newCards));
    setFlippedCards([]);
  };

  const flipCard = (index) => {
    if (flippedCards.length < 2 && !cards[index].flipped && !cards[index].matched) {
      const newCards = [...cards];
      newCards[index].flipped = true;
      setCards(newCards);
      const newFlipped = [...flippedCards, index];
      setFlippedCards(newFlipped);

      if (newFlipped.length === 2) {
        setTimeout(() => checkMatch(newFlipped), 800);
      }
    }
  };

  const checkMatch = ([first, second]) => {
    const c1 = cards[first];
    const c2 = cards[second];
    const match =
      c1.type !== c2.type &&
      matchPair(c1.text, c2.text, levels[currentLevel]);

    if (match) {
      const newCards = [...cards];
      newCards[first].matched = true;
      newCards[second].matched = true;
      setCards(newCards);
      setScore((s) => s + 1);
    } else {
      const newCards = [...cards];
      newCards[first].flipped = false;
      newCards[second].flipped = false;
      setCards(newCards);
    }
    setFlippedCards([]);
  };

  const matchPair = (text1, text2, level) => {
    let actionIndex = level.actions.indexOf(text1);
    let consequenceIndex = level.consequences.indexOf(text1);

    if (actionIndex !== -1) {
      return level.consequences[actionIndex] === text2;
    }
    if (consequenceIndex !== -1) {
      return level.actions[consequenceIndex] === text2;
    }
    return false;
  };

  return (
    <div
      style={{
        fontFamily: "'Comic Sans MS', cursive, sans-serif",
        background: "linear-gradient(to bottom, #f0f8ff, #c6f0ff)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 20,
        minHeight: "100vh",
        margin: 0,
      }}
    >
      <h3 style={{ textAlign: "center", color: "#333", textShadow: "1px 1px #fff" }}>
        🌐 Digital Footprint Memory Game 🌐
      </h3>

      <div
        style={{
          width: "95%",
          maxWidth: 900,
          background: "#fff",
          borderRadius: 15,
          padding: 20,
          boxShadow: "3px 3px 15px rgba(0,0,0,0.2)",
          margin: "15px 0",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 20, marginBottom: 10 }}>
          Level {levels[currentLevel].level}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 20,
            marginTop: 20,
          }}
        >
          {cards.map((card, idx) => (
            <div
              key={idx}
              onClick={() => flipCard(idx)}
              style={{
                width: "100%",
                height: 80,
                perspective: "1000px",
                cursor: card.matched ? "default" : "pointer",
                opacity: card.matched ? 0.6 : 1,
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  transformStyle: "preserve-3d",
                  transition: "transform 0.6s",
                  transform: card.flipped || card.matched ? "rotateY(180deg)" : "rotateY(0deg)",
                }}
              >
                {/* Front */}
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    borderRadius: 12,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "white",
                    background: "#607d8b",
                  }}
                >
                  ?
                </div>

                {/* Back */}
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    borderRadius: 12,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    fontSize: 14,
                    color: "white",
                    padding: 10,
                    transform: "rotateY(180deg)",
                    background: card.type === "action" ? "#2196f3" : "#9c27b0",
                  }}
                >
                  {card.text}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ fontSize: 18, marginTop: 10 }}>Score: {score}</div>

        <div style={{ marginTop: 15, display: "flex", justifyContent: "center", gap: 10 }}>
          <button
            style={{
              padding: "8px 15px",
              border: "none",
              borderRadius: 10,
              cursor: "pointer",
              fontSize: 14,
              background: "#2196f3",
              color: "#fff",
            }}
            onClick={() => currentLevel > 0 && setCurrentLevel(currentLevel - 1)}
          >
            ⬅ Previous Level
          </button>

          <button
            style={{
              padding: "8px 15px",
              border: "none",
              borderRadius: 10,
              cursor: "pointer",
              fontSize: 14,
              background: "#ff9800",
              color: "#fff",
            }}
            onClick={() => currentLevel < levels.length - 1 && setCurrentLevel(currentLevel + 1)}
          >
            Next Level ➡
          </button>
        </div>
      </div>

      {score >= 5 && currentLevel === levels.length - 1 && (
        <div
          style={{
            fontSize: 28,
            color: "#ff9800",
            marginTop: 20,
            textShadow: "2px 2px #fff",
          }}
        >
          🎉 You've earned the Digital Footprint Badge! 🏆
        </div>
      )}
    </div>
  );
};

export default DigitalFootprintMemory;
